import SurveyLocale from "models/SurveyLocale";

export const SET = "attributeReady/SET";
export const INIT = "attributeReady/INIT";

export const set = surveyLocale => ({
  type: SET,
  surveyLocale
});

export const init = () => ({
  type: INIT
});

const initialState = {
  surveyLocale: new SurveyLocale()
};

const attributeReady = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET: {
      const { surveyLocale } = action;
      return { ...state, surveyLocale };
    }

    case INIT: {
      return initialState;
    }

    default:
      return state;
  }
};

export default attributeReady;



// WEBPACK FOOTER //
// ./src/redux/modules/answer/attributeReady.js